export default __webpack_public_path__ + "static/media/arrow-right.ad4d16f5.svg";